"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
exports.AcModal = function (props) {
    var children = props.children, staticBackdrop = props.staticBackdrop, level = props.level, modalProps = __rest(props, ["children", "staticBackdrop", "level"]);
    var onHide = modalProps.onHide, size = modalProps.size, style = modalProps.style, show = modalProps.show, _a = modalProps.centered, centered = _a === void 0 ? true : _a, dialogAs = modalProps.dialogAs, dialogClassName = modalProps.dialogClassName, backdropClassName = modalProps.backdropClassName;
    return (react_1.default.createElement(react_bootstrap_1.Modal, __assign({}, modalProps, { show: show, onHide: onHide, bsPrefix: (level === 2 ? 'aperza-app-modal-2 ' : '') + "aperza-app-modal", dialogAs: dialogAs, dialogClassName: "aperza-app-dialog aperza-app " + (level === 2 ? 'aperza-app-dialog-2' : '') + " " + (dialogClassName != null ? dialogClassName : ''), backdropClassName: "aperza-app-backdrop " + (level === 2 ? 'aperza-app-backdrop-2' : '') + " " + (backdropClassName != null ? backdropClassName : ''), size: size, "aria-labelledby": "contained-modal-title-vcenter", centered: centered, style: style, backdrop: staticBackdrop ? 'static' : undefined }), children));
};
exports.AcModal.displayName = 'AcModal';
//# sourceMappingURL=AcModal.js.map